import {NoticeSeverity} from "@ots-frontend/ots-data";
import {Badge, BadgeProps} from "../Badge/Badge";
import {getNoticeSeverityColorRef} from "../../../util/notice-severity-ui-util";
import { FormattedDatabaseCode } from "../../text/FormattedDatabaseCode/FormattedDatabaseCode";

export type NoticeSeverityBadgeProps = Pick<BadgeProps, "variant"> & {
  value: NoticeSeverity
}

export const NoticeSeverityBadge = (props: NoticeSeverityBadgeProps) => {
  const {value, variant = "filled"} = props;

  return (
      <Badge color={getNoticeSeverityColorRef(value)} variant={variant}>
        <FormattedDatabaseCode value={value}/>
      </Badge>
  );
};
